import { render } from "./RequisitosComponent.vue?vue&type=template&id=dfa8887e"
import script from "./RequisitosComponent.vue?vue&type=script&lang=js"
export * from "./RequisitosComponent.vue?vue&type=script&lang=js"

import "./RequisitosComponent.vue?vue&type=style&index=0&id=dfa8887e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__